import { render, staticRenderFns } from "./related.vue?vue&type=template&id=4e50f2a0&scoped=true"
import script from "./related.vue?vue&type=script&lang=js"
export * from "./related.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e50f2a0",
  null
  
)

export default component.exports